<template>
  <div class="hm-card" :class="($template === 'article') ? 'article' : 'small'">
    <div class="max-w">
      <h2>How Many People Are in Your Household?</h2>
      <p>
        This includes you, your spouse, children, and other relatives you support who live with you.
      </p>
    </div>
    <SuiDivider inverted v-if="($template === 'small')"/>
      <div class="max-w">
        <div class="dependents-card">
          <p>
            Household Members
            <span class="tooltip-icon" v-tooltip="'Even if your annual income is higher than the limit, you may still qualify for Extra Help because you support other family members in your household.'">
              <img src="//hm-lis.herokuapp.com/img/svg/info-circle-solid.svg" alt="image">
            </span>
          </p>
          <SuiDropdown
            placeholder="Select One"
            selection
            fluid
            :labeled="true"
            :options="howManyPeopleOptions"
            v-model="howManyPeople"
          />
        </div>
        
        <SuiButton color="green" :class="{ 'article': ($template === 'article') }" @click="() => goNextStep('final')">Next</SuiButton>
      </div>

    </div>
</template>

<script>
  import {Button} from 'semantic-ui-vue/dist/commonjs/elements/Button';
  import {Dropdown} from 'semantic-ui-vue/dist/commonjs/modules/Dropdown';
  import {Divider} from 'semantic-ui-vue/dist/commonjs/elements/Divider';

  export default {
    name: 'PeopleInHousehold',
    components: {
      SuiButton: Button,
      SuiDropdown: Dropdown,
      SuiDivider: Divider,
    },
    data() {
      return {
        howManyPeople: null,
        howManyPeopleOptions: [0, 1, 2, 3, 4, 5, 6, 7, 8].map(n => ({text: String(n), value: n})),
      };
    },
    methods: {
      isNextDisabled() {
        return !this.$data.howManyPeople;
      },
      goNextStep(step) {
        this.$store.commit('setHowManyPeople', this.$data.howManyPeople);
        this.$store.commit('setStep', step);
        if (this.$template == 'landing') {
          window.scrollTo(0,0);
        }
      },
    },
  }
</script>
